import React, { FC, memo, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { BoxesListFilterKeys } from '../../model/types';
import { MultipleSelect } from 'shared/ui/MultipleSelect';
import { Subtype } from 'entities/Box';

interface SubTypeSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  onClear: (filterKey: string) => void;
}

export const SubTypeSelect: FC<SubTypeSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation('boxes');

  const subTypeOptions = Object.values(Subtype).map((option) => ({
    label: t(option),
    value: option,
  }));

  const clearFilter = useCallback(() => {
    onClear(BoxesListFilterKeys.subtype);
  }, [onClear]);

  const handleChange = useCallback(
    (value: string[]): void => {
      value.length ? onChange(value) : clearFilter();
    },
    [onChange, clearFilter],
  );

  return (
    <MultipleSelect
      containerClassName="flex-1"
      className="w-full"
      label={t('Subtype')}
      placeholder={t('All')}
      bordered
      allowClear
      options={subTypeOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
